import Select from '../select/index';
import Utils from '../../utils/util';
import * as CubeTree from '../../cubeTree/index';
import * as UIToolkit from '../../UIToolkit';
import { sortById } from './sortById';
import { makeSortParams } from './makeSortParams';

interface LayerCubeSortParams {
    orderFieldTypeId: number,
    orderMode: number
}

function sortAllSelected(actionType: string): void {
    let layers: CubeId[] = getCubeLayers();
    let sortParams: LayerCubeSortParams = makeSortParams(actionType);
    let orderFieldTypeId: number = sortParams.orderFieldTypeId;
    let orderMode: number = sortParams.orderMode;
    let stageWindow: StageWindow = window;
    let sortResult: FreeObjMap = stageWindow.orderAlgorithmApi.layerWareOrder(layers, orderFieldTypeId, orderMode);
    let sortTask: LayerSortTask[] = makeSortTask(sortResult.data);

    sortById(sortTask);
}

function makeSortTask(sortMapInfo: Map<CubeId, CubeId[]>): LayerSortTask[] {
    let result: LayerSortTask[] = [];

    sortMapInfo.forEach((cubeIds: CubeId[], layer: CubeId): void => {
        result.push({
            layerId: layer,
            cubeOrder: Utils.deepCopy(cubeIds)
        });
    });

    return result;
}

function getCubeLayers(): CubeId[] {
    let result: Set<CubeId> = new Set();
    let all: CubeId[] = Select.getAll();

    all.forEach((cubeId: CubeId): void => {
        if (CubeTree.isShelf(cubeId)) {
            let children: CubeId[] = CubeTree.findChildCubeIds(cubeId);

            children.forEach((layer: CubeId): void => {
                layerIsCanSort(layer) && result.add(layer);
            });
            return;
        }

        layerIsCanSort(cubeId) && result.add(cubeId);
    });

    return Array.from(result);
}

// 手动放置的层板，不能排序
function layerIsCanSort(layer: CubeId): boolean {
    if (!CubeTree.isCanDropPartition(layer)) {
        return false;
    }

    let layoutType: LayoutType = UIToolkit.layoutType(layer);

    if (layoutType === '|-|--|---') {
        return false;
    }

    return true;
}

export {
    sortAllSelected,
    makeSortParams
};
